import { useMemo } from 'react';
import { sqTrendCapsuleStore } from '@/core/core.stores';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { useCapsuleRuntimeItems } from '@/trendData/capsuleRuntime.store';
import { mergeCapsuleSelection } from '@/trendData/trendCapsule.utilities';
import type { CapsuleItem } from '@/trendData/trendData.types';

/**
 * The capsule items with the flux-owned selection merged in, re-rendering on either source. The
 * runtime store owns the items; the flux store owns `selectedCapsules`.
 */
export function useCapsuleItems(): CapsuleItem[] {
  const runtimeItems = useCapsuleRuntimeItems();
  const selectedCapsules = useFluxPath(sqTrendCapsuleStore, (store) => store.selectedCapsules);

  return useMemo(() => mergeCapsuleSelection(runtimeItems, selectedCapsules), [runtimeItems, selectedCapsules]);
}
